import { QueryBus } from '@skylab-shared/core';
import { Constructor, IDisposable } from '@skylab-shared/types';
import { PagedCollectionQuery } from '../query/paged-collection-query';


export interface ListPaginationSettings {
    pageNumber: number;
    pageSize: number;
}

export interface ListFilterSettings {
    pattern: string;
}

export class QuickListDataSourceBase<TQuery extends PagedCollectionQuery<TItem>, TItem> implements IDisposable {
    private queryType: Constructor<TQuery>;
    protected paramsFunction: (() => unknown) | null = null;

    public constructor( private readonly queryBus: QueryBus) { }

    public setQueryType(queryType: Constructor<TQuery>): void {
        this.queryType = queryType;
    }

    public setParamsFunction(params: (() => unknown) | null): void {
        this.paramsFunction = params;
    }

    public quickListAsync(
        pagination: ListPaginationSettings,
        filter: ListFilterSettings
    ): Promise<TItem[]> {
        const query = new this.queryType({
            pageNo: pagination.pageNumber,
            pageSize: pagination.pageSize,
            quickSearch: filter.pattern || null
        });
        return this.queryBus.queryAsync(query, this.paramsFunction?.())
            .then(({ items }) => items);
    }

    public dispose(): void { }
}
